import React from 'react';
import { App } from '@capacitor/app';
import { useClerk } from '@clerk/clerk-react';
import { isNative } from './native';
import { handleNativeAuthUrl } from './nativeAuth';

/**
 * מאזין ל-deep link של ההתחברות (funnermobile://auth?ticket=...) גם כשהמשתמש עדיין
 * לא מחובר — לכן מחובר ב-App.tsx מעל ה-router, ולא ב-NativeBootstrap.
 */
export default function NativeAuthUrlListener() {
  const clerk = useClerk();

  React.useEffect(() => {
    if (!isNative) return undefined;

    const handle = App.addListener('appUrlOpen', ({ url }) => {
      void handleNativeAuthUrl(url, clerk);
    });

    // האפליקציה עשויה להיפתח ישירות מה-deep link (הייתה סגורה)
    App.getLaunchUrl()
      .then((launch) => {
        if (launch?.url) void handleNativeAuthUrl(launch.url, clerk);
      })
      .catch(() => undefined);

    return () => {
      handle.then((h) => h.remove()).catch(() => undefined);
    };
  }, [clerk]);

  return null;
}
